/**
 * TrustGate Console - MetricTile Component
 * KPI metric display tile
 */

import React from 'react';

interface MetricTileProps {
  label: string;
  value: string | number;
  trend?: string;
  className?: string;
  loading?: boolean;
}

export const MetricTile: React.FC<MetricTileProps> = ({ 
  label, 
  value, 
  trend,
  className = '',
  loading = false 
}) => {
  return (
    <div className={`bg-[#1a1a2e] border border-white/10 rounded-xl p-4 ${className}`}>
      <div className="text-sm text-[#cbd5e1] mb-2">{label}</div>
      {loading ? (
        <div className="h-8 w-16 bg-white/5 animate-pulse rounded"></div>
      ) : (
        <div className="text-2xl font-bold text-[#f8fafc]">{value}</div>
      )}
      {trend && !loading && (
        <div className="text-xs text-[#cbd5e1] mt-1">{trend}</div>
      )}
    </div>
  );
};
